"use client";

import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import styles from "./LeadFormNew.module.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import HomeConnectModalFormNew from "@/revamp/sections/HomeNewFaq/HomeConnectModalFormNew";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { landingPagesApplicationJourneyFlow } from "@/components/molecules/Forms/LandingPageConnectModalForm/utils";
import { StorageService } from "@/helpers/storage.service";
import { usePathname } from "next/navigation";
import ApplicationFormRedirectLoader from "../ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";

type LeadFormWrapperNewProps = {
  associatedPrograms?: any[];
  isLambdaAPI?: boolean;
  isSpecificPage?: boolean;
  isFaq?: boolean;
  isProgram?: boolean;
  RFIHeading?: string;
  seatsFilledUI?: number;
  isSeatsFilledUI?: boolean;
  isProgramListPage?: boolean;
  isMobile?: boolean;
  landingPageValue?: string;
  showStatsCards?: boolean;
  Heading?: string;
};

const LeadFormWrapperNew = ({
  associatedPrograms = [],
  isLambdaAPI = false,
  isSpecificPage = false,
  isFaq = false,
  isProgram=false,
  RFIHeading,
  seatsFilledUI,
  isSeatsFilledUI = false,
  isProgramListPage = false,
  isMobile = false,
  landingPageValue = "",
  showStatsCards,
  Heading=""
}: LeadFormWrapperNewProps) => {
  const [message, setMessage] = useState(false);
  const [isOtpValidated, setIsOtpValidated] = useState(false);
  const [leadFailed, setLeadFailed] = useState(false);
  const [formResponse, setFormResponse] = useState(null);
  const counterInterval = useRef(null);
  const [loadingCount, setLoadingCount] = useState(3);
  const isExistingLeadRef = useRef(false);
  const emailIdRef = useRef(null);
  const path = usePathname();
  const isAfricaPage = path == "/africa";

  const [
    isApplicationRedirectLoaderDisabled,
    setApplicationRedirectLoaderDisabled,
  ] = useState(true);

  const [apiResponseURL, setAPIResposeURL] = useState<string | null>(null);

  const clickedInsideLeadForm = useRef(false);

  const handleClickInsideLeadForm = () => {
    if (!clickedInsideLeadForm.current) {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Get Free Counselling",
        section_name: "Footer",
        header_title: "NA",
        page_type: "Home Page",
        page_url: window.location.href || "NA",
      });

      updateStateSession({
        parentSection: "Footer",
        leadStartingCta: "Get Free Counselling",
      });

      window?.webengage?.track("Open RFI Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
        "Section Name": "Footer",
      });

      clickedInsideLeadForm.current = true;
    }
  };

  const resetState = () => {
    setIsOtpValidated(false);
    setLoadingCount(3);
    setApplicationRedirectLoaderDisabled(true);
    isExistingLeadRef.current = false;
  };

  const startLoader = () => {
    counterInterval.current = setInterval(() => {
      setLoadingCount((count) => {
        if (count < 1) {
          clearInterval(counterInterval.current);
          if (
            isAfricaPage ||
            (isExistingLeadRef.current &&
              landingPagesApplicationJourneyFlow.includes(path))
          ) {
            window.location.href = sessionStorage.getItem("redirectionUrl");
          } else {
            StorageService.set("emailEvent", emailIdRef.current);
            window.location.href = `/thankyou`;
          }

          setTimeout(() => {
            resetState();
          }, 2000);
          return 0;
        } else {
          return count - 1;
        }
      });
    }, 1000);
  };

  useEffect(() => {
    if (isOtpValidated && isLambdaAPI) {
      setApplicationRedirectLoaderDisabled(false);
      startLoader();
    }
    return () => {
      setIsOtpValidated(false);
    };
  }, [isOtpValidated]);

  const handleOtpValidation = useCallback((status: boolean) => {
    setIsOtpValidated(status);
  }, []);

  const handleLeadCheck = useCallback((status: boolean) => {
    setLeadFailed(status);
  }, []);

  return (
    <div
      className={`${styles.root} ${isFaq && styles.faqroot}`}
      onClick={handleClickInsideLeadForm}
    >
      {!isApplicationRedirectLoaderDisabled ? (
        !isLambdaAPI ? (
          <div>
            <div className={styles.thankYou}>Thank You For Your Interest!</div>

          <div className={styles.paragraph}>
            We have successfully received your information. One of our
            counsellors will contact you shortly.
          </div>

          <a href={apiResponseURL || "#"} className={styles.proceedToApply}>
            Proceed to Apply
          </a>
        </div>
      ) : (
        <div className={styles.container}>
          <ApplicationFormRedirectLoader
            redirectTime={loadingCount}
            text={isAfricaPage ? undefined : ""}
          />
        </div>
      )
    ) : (
        <div className={styles.formSection}>
          <OTPContextProvider isLambdaAPI={isLambdaAPI}>
            <OTPContext.Consumer>
              {({ isOTPSent }) => (
                <>
                  {!isOTPSent &&
                    (isProgram ? (
                      <div className={styles.programHeading}>{RFIHeading}</div>
                    ) : isProgramListPage ? (
                      <div className={styles.programListPageHeading}>
                        Connect with our experts
                      </div>
                    ) : (
                      <div className={styles.heading}>
                       {Heading?.length>0 ? Heading: "Still have questions? Talk to an expert"}  
                      </div>
                    ))}
                  <OTPContextWrapper isNewProgramTemp={true}>
                    <HomeConnectModalFormNew
                      isSpecificPage={isSpecificPage}
                      associatedPrograms={associatedPrograms}
                      setMessage={setMessage}
                      setFormResponse={setFormResponse}
                      isOtpValidated={handleOtpValidation}
                      checkLeadFail={handleLeadCheck}
                      setApplicationRedirectLoaderDisabled={
                        setApplicationRedirectLoaderDisabled
                      }
                      setAPIResposeURL={setAPIResposeURL}
                      isProgram={isProgram}
                      seatsFilled={seatsFilledUI}
                      isSeatsFilled={isSeatsFilledUI}
                      isProgramListPage={isProgramListPage}
                      isMobile={isMobile}
                      landingPageValue={landingPageValue}
                      showStatsCards={showStatsCards}
                      isLambdaAPI={isLambdaAPI}
                    />
                  </OTPContextWrapper>
                </>
              )}
            </OTPContext.Consumer>
          </OTPContextProvider>
        </div>
      )}
    </div>
  );
};

export default LeadFormWrapperNew;
